export default class FixedNavbar {
	constructor(el) {
		if (!el) return;
		this.body = document.body;
		this.headerEl = el;
		this.offset = this.headerEl.offsetHeight;

		if (this.headerEl.dataset.scrolledHeight && document.querySelector(this.headerEl.dataset.scrolledHeight)) {
			this.offset = document.querySelector(this.headerEl.dataset.scrolledHeight).getBoundingClientRect().top;
		}

		this.events();
	}

	hasScrolled() {
		document.body.classList.add('has-scrolled');
	}

	notScrolled() {
		document.body.classList.remove('has-scrolled');
	}

	onScroll() {
		if (this.headerEl.dataset.scrolledHeight && document.querySelector(this.headerEl.dataset.scrolledHeight)) {
			this.offset = document.querySelector(this.headerEl.dataset.scrolledHeight).getBoundingClientRect().top;
		}
		this.scrollPos = window.pageYOffset || document.body.scrollTop;
		if (this.scrollPos >= this.offset) {
			this.hasScrolled();
		} else {
			this.notScrolled();
		}
	}

	events() {
		window.addEventListener('scroll', this.onScroll.bind(this), false);
	}
}
